/* import __COLOCATED_TEMPLATE__ from './payment.hbs'; */
import { ensureSafeComponent } from '@embroider/util';
import { importSync } from '@embroider/macros';
import Component from '@glimmer/component';

export default class SiteBillingAccountHistoryContainersPayment extends Component {
  get columns() {
    const PAYMENT_COLUMNS = [
      { name: '', componentSuffix: 'timeline-toggle' },
      { name: 'Date', componentSuffix: 'date' },
      { name: 'Details', componentSuffix: 'details' },
      { name: 'Charges', componentSuffix: 'charges' },
      { name: 'Payments', componentSuffix: 'payments' },
      { name: 'Balance', componentSuffix: 'balance' },
    ];

    return PAYMENT_COLUMNS.map(column => {
      let module = importSync(`../cells/${column.componentSuffix}`);
      column.columnComponent = ensureSafeComponent(module.default, this);
      return column;
    });
  }
}
